import { type IValidationSchema, validationContext } from 'validx'
import type { LegendPartDependencies } from '@/features/legends/editor/legend-part-dependencies'
import { LegendPartViewModelBase } from '@/features/legends/editor/LegendPartViewModelBase'
import {
  addGenericErrorForProperty,
  type ErrorDescriptor,
} from '@/features/legends/editor/analyzer-errors'
import { validateObject } from '@/utils/validx-util'
import type { DataSourcesConfig } from './data-sources'
import { RoutingContextSourcesBuilderViewModel } from './RoutingContextSourcesBuilderViewModel'

/**
 * Extra data the legend brings in.
 */
export class DataSourcesEditorViewModel extends LegendPartViewModelBase {
  private readonly _schema: IValidationSchema<DataSourcesEditorViewModel> = {
    routingContextSources: [
      validateObject('There are invalid routing context sources.'),
    ],
  }

  /**
   * The data routing filters can use.
   */
  readonly routingContextSources: RoutingContextSourcesBuilderViewModel

  readonly validation = validationContext(this, this._schema)

  constructor(dependencies: LegendPartDependencies) {
    super(dependencies)
    this.routingContextSources = new RoutingContextSourcesBuilderViewModel(
      dependencies,
    )
    this.lifecycle.manage(this.routingContextSources)
  }

  /**
   * Sets the data sources from the legend document.
   */
  hydrate(config: DataSourcesConfig | undefined) {
    this.routingContextSources.hydrate(config?.routingContextSources)
  }

  /**
   * Shows the analyzer's errors on the data sources.
   */
  receiveErrors(descriptor: ErrorDescriptor) {
    addGenericErrorForProperty(
      this,
      descriptor.inner?.routingContextSources,
      'routingContextSources',
      'There are invalid routing context sources',
    )
    this.routingContextSources.receiveErrors(
      descriptor.inner?.routingContextSources,
    )
  }

  /**
   * The data sources as the legend document has them.
   */
  toJSON(): DataSourcesConfig {
    return {
      routingContextSources: this.routingContextSources.toJSON(),
    }
  }
}
